import { AssertIsNilException } from './assert-is-nil.exception';
import { isNil } from '@pct-ts/typeguard';

export function assertIsNil(value: unknown, message: string): asserts value is null | undefined {
  if (!isNil(value)) {
    throw new AssertIsNilException(`Not a nil: ${message}`);
  }
}
